'use strict';

module.exports = [function () {
    return {
        replace: true,
        scope: true, 
        template: require('./tableButtonAdd.html')
    };
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableButtonAdd.js
// module id = 372
// module chunks = 0